import AxiosClient from "../../../services/axios.services";

class MatrizEvaluacionPuestoServices {
  getMatrizEvaluacionPuesto = (params) =>
    AxiosClient.get("/api/app/carrera_sucesion_creacion_matriz/", {
      // AxiosClient.get("/api/app/carrera_sucesion_matriz_criticidad/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  saveMatrizEvaluacionPuesto = (data) =>
    // AxiosClient.post("/api/app/carrera_sucesion_matriz_criticidad/", data, {
    AxiosClient.post("/api/app/carrera_sucesion_creacion_matriz/", data, {
      headers: { "Content-Type": "application/json" },
    });
  editMatrizEvaluacionPuesto = (id, data) =>
    // AxiosClient.put(
    //   `/api/app/carrera_sucesion_matriz_criticidad/${id}/`,
    //   data,
    AxiosClient.put(`/api/app/carrera_sucesion_creacion_matriz/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });
  deleteMatrizEvaluacionPuesto = (id) =>
    // AxiosClient.delete(`/api/app/carrera_sucesion_matriz_criticidad/${id}`, {
    AxiosClient.delete(`/api/app/carrera_sucesion_creacion_matriz/${id}`, {
      headers: { "Content-Type": "application/json" },
    });


  getModalMatrizEvaluacion = (params) =>
    AxiosClient.get("/api/app/modal_matriz_evaluacion/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });


}

export default new MatrizEvaluacionPuestoServices();
